import templateUrl from "emun.vendor/vendor-users.htm";
import controller from "emun.auth/users/user-manager.controller";

export default {
  // require: {
  //     container: '^retailerContainer'
  // },
  bindings: {
    vendorId: "@",
    preventEdit: "<?"
  },
  controller,
  templateUrl
};
